import {
  DEFAULT_LOCALE,
  LOCALE_COOKIE,
  isLocale,
  localeFromPathname,
  type Locale,
} from "./locales";

/**
 * Active locale for the current render.
 * Server: set once per request from the URL prefix or the locale cookie.
 * Client: derived from the URL prefix, falling back to the cookie — the same
 * inputs the server used, so hydration stays stable.
 */
let serverLocale: Locale = DEFAULT_LOCALE;

export function setRequestLocale(locale: Locale) {
  serverLocale = locale;
}

function cookieLocale(): Locale | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`${LOCALE_COOKIE}=([^;]+)`));
  const value = match?.[1]?.toLowerCase();
  return isLocale(value) ? (value as Locale) : null;
}

export function detectLocale(): Locale {
  if (typeof window === "undefined") return serverLocale;
  return localeFromPathname(window.location.pathname) ?? cookieLocale() ?? DEFAULT_LOCALE;
}
